import { Component, OnInit } from "@angular/core";

import { AuthService } from "src/app/shared/providers/auth/auth-service.service";

@Component({
  selector: "app-keycloak",
  templateUrl: "./keycloak.component.html",
  styleUrls: ["./keycloak.component.scss"]
})
export class KeycloakComponent implements OnInit {
  constructor(private authService: AuthService) {
    this.authService.configure();
  }

  ngOnInit() {}
}
